var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.editorType + "虚拟销量任务",
        "before-close": _vm.close,
        width: "900px",
        "custom-class": "task-editor",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-row",
        { attrs: { justify: "space-between" } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticClass: "tree-wrapper mb16" },
              [
                _c("el-tree", {
                  ref: "treeRef",
                  attrs: {
                    data: _vm.tree,
                    "node-key": "id",
                    "show-checkbox": "",
                    "default-expand-all": "",
                    props: { label: "name", children: "child" },
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-form",
                {
                  ref: "editorFormRef",
                  attrs: {
                    rules: _vm.formRules,
                    model: _vm.formData,
                    "label-width": "100px",
                    size: "large",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "form-input",
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "执行间隔", prop: "scheduleValue" } },
                    [
                      _vm._v(" 每 "),
                      _c("el-input-number", {
                        staticClass: "form-input ml10 mr10",
                        staticStyle: { width: "70px" },
                        attrs: {
                          min: 1,
                          max: 31,
                          controls: false,
                          precision: 0,
                        },
                        on: { blur: _vm.handleScheduleValueBlur },
                        model: {
                          value: _vm.formData.scheduleValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "scheduleValue", $$v)
                          },
                          expression: "formData.scheduleValue",
                        },
                      }),
                      _vm._v(" 天 "),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-bottom": "0 !important" },
                      attrs: { label: "执行时间", required: true },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "executeHour" } },
                            [
                              _c("el-input-number", {
                                staticClass: "form-input",
                                staticStyle: { width: "70px" },
                                attrs: {
                                  precision: 0,
                                  min: 0,
                                  max: 23,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.executeHour,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "executeHour", $$v)
                                  },
                                  expression: "formData.executeHour",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 1 } }, [_vm._v("时")]),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "executeMinute" } },
                            [
                              _c("el-input-number", {
                                staticClass: "form-input",
                                staticStyle: { width: "70px" },
                                attrs: {
                                  precision: 0,
                                  min: 0,
                                  max: 59,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.executeMinute,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "executeMinute", $$v)
                                  },
                                  expression: "formData.executeMinute",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 15 } }, [_vm._v("分")]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "增长方式" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.increaseType,
                            callback: function ($$v) {
                              _vm.increaseType = $$v
                            },
                            expression: "increaseType",
                          },
                        },
                        _vm._l(_vm.increaseTypeOptions, function (item, i) {
                          return _c(
                            "el-radio",
                            { key: "option" + i, attrs: { label: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.increaseType === 0,
                          expression: "increaseType === 0",
                        },
                      ],
                      key: "increaseValueItem",
                      attrs: {
                        label: "增长值",
                        prop: "increaseValue",
                        required: _vm.increaseValueRequired,
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "form-input",
                        staticStyle: { width: "70px" },
                        attrs: { min: 1, controls: false, precision: 0 },
                        model: {
                          value: _vm.formData.increaseValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "increaseValue", $$v)
                          },
                          expression: "formData.increaseValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.increaseType === 1,
                          expression: "increaseType === 1",
                        },
                      ],
                      key: "rangeValueItem",
                      staticStyle: { "margin-bottom": "0 !important" },
                      attrs: {
                        label: "增长区间",
                        required: _vm.rangeValueRequired,
                      },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "minValue" } },
                            [
                              _c("el-input-number", {
                                staticClass: "form-input",
                                staticStyle: { width: "70px" },
                                attrs: {
                                  precision: 0,
                                  min: 1,
                                  controls: false,
                                },
                                model: {
                                  value: _vm.formData.minValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "minValue", $$v)
                                  },
                                  expression: "formData.minValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "line", attrs: { span: 1 } },
                        [_vm._v(" - ")]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 19 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "maxValue" } },
                            [
                              _c("el-input-number", {
                                staticClass: "form-input",
                                staticStyle: { width: "70px" },
                                attrs: {
                                  min: _vm.formData.minValue
                                    ? _vm.formData.minValue + 1
                                    : undefined,
                                  controls: false,
                                  precision: 0,
                                },
                                model: {
                                  value: _vm.formData.maxValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "maxValue", $$v)
                                  },
                                  expression: "formData.maxValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.formData.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "remark", $$v)
                          },
                          expression: "formData.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "220px" },
                  attrs: { type: "flex", justify: "end" },
                },
                [
                  _c("el-button", { on: { click: _vm.close } }, [
                    _vm._v("取消"),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }